<template>
<div class="container">
  <div class="next">
    <div style="text-align: center">
      <h1 @click="toNew(id)" style="cursor: pointer">
        <img :src="logo"  >
        {{title}}
      </h1>
    </div>
    <div class="container-p">{{description}}<a v-if="title!=''" @click="toNew(id)" class="a_herf">详情</a>
    </div>
  </div>

</div>
</template>

<script>
import logo from '@/assets/t.png'
import axios from "axios";
import {orgId, requestUrl} from "../common/cons";
export default {
  name: "HomeNav",
  data(){
    return{
      logo:logo,
      title:'',
      description:'',
      id:0
    }
  },
  mounted() {
    this.getNoticeList()
  },
  methods:{
    async getNoticeList () {
      const result = await axios.get(`${requestUrl}/notice/${orgId}`)
      let i=result.data.length;
      if(result.data.length>0&&result.data[i-1].weight<2){
        this.title = result.data[i-1].title
        this.description = result.data[i-1].description
        this.id=result.data[i-1].article_id;
      }else {
        this.title=""
        this.description=""
      }
    },
    toNew(id){
      if(id!=0){
        // this.$router.push(`/content/${id}`)
        const routePath = this.$router.resolve({
          path: `/content/${id}`
        })
        window.open(routePath.href)
      }

    }
  }
}
</script>

<style scoped>
.container{
  clear: both;
}
.next{
  background-color: white;
  margin: 0 auto;
  margin-top: 20px;
  width: 100%;
}
h1 img{
  width: 30px;
  height: 30px;
  position: relative;
  top: 4px;
}
.container h1{
  /*color: cornflowerblue;*/
  font-size: 30px;
  color: #2574c2;
  font-family: 微软雅黑;
  font-weight: normal;
}
.container h6{
  color: #999999;
  font-size: 18px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.container-p{
  overflow: hidden;
  line-height: 30px;
  color: #999999;
  margin: 0 20px 20px 20px;
}
.a_herf{
  text-decoration: none;
  margin-left: 5px;
  color: #2574c2;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/HomeNav.vue